import { useEffect, useState } from 'react';

const INITIAL_VIEW_STATE = {
  reportParameters: {},
  routeName: ''
};

const useEducationReporting = () => {
  const [viewState, setViewState] = useState({ ...INITIAL_VIEW_STATE });

  useEffect(() => {
    setViewState({
      ...viewState,
      reportParameters: {},
      routeName: 'EDUCATION_REPORTING'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ...viewState };
};

export default useEducationReporting;